var searchableFields = ['value', 'label', 'description', 'labelTag'];
var searchableTagFields = ['tags', 'filteringTags'];
export var matchesString = function (value, searchText) {
    return value && value.toLowerCase().indexOf(searchText) !== -1;
};
var matchesSingleOption = function (dropdownOption, text) {
    var searchText = text.toLowerCase();
    var option = dropdownOption.option;
    var searchStrFields = function (attr) { return matchesString(option[attr], searchText); };
    var searchTagsFields = function (attr) { var _a; return (_a = option[attr]) === null || _a === void 0 ? void 0 : _a.some(function (value) { return matchesString(value, searchText); }); };
    return searchableFields.some(searchStrFields) || searchableTagFields.some(searchTagsFields);
};
export var filterOptions = function (options, searchText) {
    if (searchText === void 0) { searchText = ''; }
    if (searchText === '') {
        return options;
    }
    var currentGroup = null;
    return options.reduce(function (acc, option) {
        if (option.type === 'parent') {
            currentGroup = option;
            return acc;
        }
        if (option.type !== 'child') {
            currentGroup = null;
        }
        if (matchesSingleOption(option, searchText)) {
            if (currentGroup) {
                acc.push(currentGroup);
                currentGroup = null;
            }
            acc.push(option);
        }
        return acc;
    }, []);
};
//# sourceMappingURL=filter-options.js.map